// From: https://github.com/hotwired/turbo/issues/55#issuecomment-1206580229
//
// How to use: <%= link_to( " A great product", "products/#{product.id}", data: {controller: "click", action: "click#onlyOnce"})
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  onlyOnce() {
    let linkHref = this.element.href

    // 1 ms wait to allow the original action to start
    setTimeout(() => {
      this.disableLink()
      this.waitThenReEnable(linkHref)
    }, 1)
  }

  //private

  disableLink(){
    this.element.href = "javascript:void(0)"
  }

  waitThenReEnable(linkHref){
    // in case there is an issue, the link is re-enable after 3 seconds
    setTimeout(() => {
      if (this.element) this.element.href = linkHref;
    }, 3000)
  }
}
